import React, { useState, useRef } from "react";
import { Button, Row, Col, Card, Form, Spinner } from "react-bootstrap";
import HtmlHead from "components/html-head/HtmlHead";
import BreadcrumbList from "components/breadcrumb-list/BreadcrumbList";
import CsLineIcons from "cs-line-icons/CsLineIcons";
import "intro.js/introjs.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useHistory, useLocation } from "react-router-dom";
import moment from "moment";
import uploadImageToS3 from "helper/AWS";
import { Fetch } from "helper/api";
import { toast } from "react-toastify";

const Banner = () => {
  const title = "New Banner";
  const description = "Add Update Banner";
  const [validated, setValidated] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const banner = location.state?.banner;
  console.log(banner, "4545");

  const fileInputRef = useRef(null);

  const [formData, setFormData] = useState({
    mediaType: banner?.image_url
      ? "image"
      : banner?.video_url
      ? "video"
      : "image",
    isActive: banner?.is_active ?? true,
    bannerName: banner?.name ?? "",
    startDate: banner?.start_date ? moment(banner.start_date).toDate() : "",
    endDate: banner?.end_date ? moment(banner.end_date).toDate() : "",
    redirectionLink: banner?.redirection_link ?? "",
    description: banner?.description ?? "",
    file: null,
    previewUrl: banner?.image_url ?? null,
  });

  const [isUploading, setIsUploading] = useState(false);
  const isEdit = banner ? true : false;

  const breadcrumbs = [
    { to: "", text: "Home" },
    { to: "application/banners", text: "Banners" },
    { to: "application/banners/add", text: "Add" },
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFormData((prev) => ({
          ...prev,
          file: file,
          previewUrl: reader.result,
        }));
      };
      reader.readAsDataURL(file);
    }
  };

  const handleUploadClick = () => {
    fileInputRef.current?.click();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      return;
    }

    setIsUploading(true);
    try {
      let mediaUrl = formData.previewUrl;

      if (formData.file) {
        mediaUrl = await uploadImageToS3(formData.file);
        console.log(mediaUrl);
      }

      const formattedData = {
        name: formData.bannerName,
        description: formData.description,
        redirection_link: formData.redirectionLink,
        media: formData.mediaType,
        is_active: formData.isActive,
        image_url: formData.mediaType === "image" ? mediaUrl : null,
        video_url: formData.mediaType === "video" ? mediaUrl : null,
        start_date: moment(formData.startDate).toISOString(),
        end_date: moment(formData.endDate).toISOString(),
        banner_id: banner ? banner._id : null,
      };

      console.log(formattedData, "formattedData");
      const { banner_id, ...updatedData } = formattedData;
      const response = await Fetch("admin/banner", {
        method: isEdit ? "PUT" : "POST",
        body: JSON.stringify(isEdit ? formattedData : formattedData),
      });

      if (response.success) {
        toast.success(response.message || "Banner created successfully!");
        history.push("/application/banners");
      }
    } catch (error) {
      console.error("Error submitting the form:", error.message);
      toast.error("An error occurred while submitting the form.");
    } finally {
      setIsUploading(false);
    }
    setValidated(true);
  };

  const renderUploadPlaceholder = () => (
    <div
      onClick={handleUploadClick}
      className="upload-placeholder cursor-pointer border border-1 border-separator rounded-sm"
      style={{ minHeight: "250px" }}
    >
      <div className="d-flex flex-column align-items-center justify-content-center h-100">
        {formData.previewUrl ? (
          <div className="position-relative w-100 h-100">
            <img
              src={formData.previewUrl}
              alt="preview"
              className="w-100 h-100 object-fit-cover rounded-sm"
            />
            <div className="position-absolute top-0 end-0 m-2">
              <div className="bg-success rounded-pill p-1">
                <CsLineIcons icon="check" size="12" className="text-white" />
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className="upload-icon mb-3">
              <CsLineIcons icon="upload" size="24" className="text-primary" />
            </div>
            <p className="mb-1">Drop your {formData.mediaType} here</p>
            <p className="text-muted small">or click to browse</p>
            <p className="text-muted smallest">
              {formData.mediaType === "image"
                ? "PNG, JPG or GIF"
                : "MP4, WebM or OGG"}{" "}
              (max. 800x400px)
            </p>
          </>
        )}
      </div>
      <input
        ref={fileInputRef}
        type="file"
        className="d-none"
        accept={formData.mediaType === "image" ? "image/*" : "video/*"}
        onChange={handleFileSelect}
      />
    </div>
  );

  return (
    <>
      <HtmlHead title={title} description={description} />
      <div className="page-title-container">
        <Row>
          <Col md="8">
            <h1 className="mb-0 pb-0 display-4">{title}</h1>
            <BreadcrumbList items={breadcrumbs} />
          </Col>
        </Row>

        <Card body className="mb-5 mt-5">
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Row className="mb-3 g-3">
              <Col md="6">{renderUploadPlaceholder()}</Col>

              <Col md="6">
                <Form.Group className="mb-3">
                  <Form.Label className="mb-3">Media Type</Form.Label>
                  <div className="d-flex gap-4">
                    <Form.Check
                      type="radio"
                      name="mediaType"
                      label="Image"
                      value="image"
                      checked={formData.mediaType === "image"}
                      onChange={handleInputChange}
                    />
                    <Form.Check
                      type="radio"
                      name="mediaType"
                      label="Video"
                      value="video"
                      checked={formData.mediaType === "video"}
                      onChange={handleInputChange}
                    />
                  </div>
                </Form.Group>
                <Form.Group className="mb-3">
                  <Form.Label>Active</Form.Label>
                  <Form.Check
                    type="switch"
                    name="isActive"
                    checked={formData.isActive}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        isActive: e.target.checked,
                      }))
                    }
                  />
                </Form.Group>
                <Form.Group controlId="bannerName">
                  <Form.Label>Banner Name</Form.Label>
                  <Form.Control
                    required
                    type="text"
                    name="bannerName"
                    value={formData.bannerName}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>

              <Col md="6">
                <Form.Group>
                  <Form.Label>Start Date</Form.Label>
                  <DatePicker
                    className="form-control"
                    selected={formData.startDate}
                    onChange={(date) =>
                      setFormData((prev) => ({ ...prev, startDate: date }))
                    }
                    selectsStart
                    startDate={formData.startDate}
                    endDate={formData.endDate}
                  />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group>
                  <Form.Label>End Date</Form.Label>
                  <DatePicker
                    className="form-control"
                    selected={formData.endDate}
                    onChange={(date) =>
                      setFormData((prev) => ({ ...prev, endDate: date }))
                    }
                    selectsEnd
                    startDate={formData.startDate}
                    endDate={formData.endDate}
                    minDate={formData.startDate}
                  />
                </Form.Group>
              </Col>
              <Col md="12">
                <Form.Group>
                  <Form.Label>Redirection Link</Form.Label>
                  <Form.Control
                    type="text"
                    name="redirectionLink"
                    value={formData.redirectionLink}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>
              <Col md="12">
                <Form.Group>
                  <Form.Label>Description</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="description"
                    value={formData.description}
                    onChange={handleInputChange}
                  />
                </Form.Group>
              </Col>

              <Col md="12" className="mt-4">
                <Button type="submit" variant="primary" disabled={isUploading}>
                  {isUploading ? (
                    <>
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className="me-2"
                      />
                      Saving...
                    </>
                  ) : (
                    "Save Banner"
                  )}
                </Button>
              </Col>
            </Row>
          </Form>
        </Card>
      </div>
    </>
  );
};

export default Banner;
